import React, { type FC } from 'react'

import { Flex, Image, Link, Tooltip, useToast } from '@chakra-ui/react'
import * as CSS from 'csstype'
import { useTranslation } from 'react-i18next'

import ApplyV2Tooltip from '@core/components/ApplyDialogV2/ApplyV2Tooltip'
import { prefixes } from '@core/utils/helpers/prefixes'

// const formatPhoneNumber = (prefixStr: string | undefined | null = '', phone: string): string => {
//     let cleaned = phone.replace(/\s+/g, '')
//     if (prefixStr && cleaned.startsWith(prefixStr + prefixStr)) {
//         cleaned = cleaned.replace(prefixStr + prefixStr, prefixStr)
//     }
//     const prefixLength = prefixStr && prefixStr?.length > 0 ? prefixStr.length - 1 : 0
//     const regex = new RegExp(`(\\+\\d{${prefixLength}})(\\d+)`)
//     if (prefixLength > 0) {
//         return cleaned.replace(regex, '$1 $2')
//     }
//     return cleaned.replace(regex, '$1$2')
// }

const baseClass = 'ContactPerson__contact-link'

interface PersonContactLinkProps {
    type?: 'tel' | 'mailto'
    value: string
    phonePrefix?: string | null
    fontSize?: string | number
    color?: string
}

const PersonContactLink: FC<PersonContactLinkProps> = ({
    type = 'mailto',
    value,
    phonePrefix = '',
    fontSize = 'sm',
    color = '#1A1A1A',
}) => {
    const toast = useToast()
    const { t } = useTranslation()

    const rawPhone = `${phonePrefix || ''}${value}`
    const cleanPhoneForLogic = rawPhone.replace(/[^\d+]/g, '')
    const findPrefix = () => {
        return prefixes.find(({ prefix }) => cleanPhoneForLogic.startsWith(prefix))
    }

    const displayValue = type === 'tel' ? rawPhone : value
    const actionValue = type === 'tel' ? cleanPhoneForLogic : value

    // const findPrefix = () => {
    //     return prefixes.find(({ prefix }) => `${phonePrefix || ''}${value}`.startsWith(prefix))
    // }
    // const formatedPhone = formatPhoneNumber(prefixItem?.prefix, `${phonePrefix || ''}${value}`)
    const prefixItem = type === 'tel' ? findPrefix() : null

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(actionValue)
            toast({
                title: t('6272'),
                description: displayValue,
                status: 'success',
                duration: 2000,
                isClosable: true,
            })
        } catch (error) {
            console.log('Copy error:', error)
            toast({
                title: t('3875'),
                description: displayValue,
                status: 'error',
                duration: 2000,
                isClosable: true,
            })
        }
    }

    return (
        <Flex className={baseClass} fontSize={fontSize} gap={'8px'}>
            {type === 'tel' && (
                <Image
                    src={`${
                        process.env.ENV === 'local' ? process.env.API_URL : window.location.origin
                    }/${prefixItem?.code}`}
                    fallbackSrc={''}
                    maxW={4}
                />
            )}
            <Link
                href={`${type}:${actionValue}`}
                // display={'block'}
                // maxW={'208px'}
                // overflow={'hidden'}
                // whiteSpace={'nowrap'}
                // textOverflow={'ellipsis'}
                alignItems={'center'}
                gap={'8px'}
                fontWeight={'semibold'}
                color={color}
                _hover={{ textDecoration: 'underline', cursor: 'pointer' }}
                wordBreak={'break-word'}
                whiteSpace={'normal'}
                overflowWrap={'break-word'}
                // sx={{
                //     wordBreak: 'break-word', // Розриває довгі слова при необхідності
                //     whiteSpace: 'normal', // Дозволяє переносити текст на новий рядок
                //     overflowWrap: 'break-word', // Альтернативна властивість для переносу
                // }}
            >
                {displayValue}
            </Link>
            <ApplyV2Tooltip label={t('5708', 'Copy')} openDelay={1}>
                <i className="fa-regular fa-clone ContactPerson__modal__icon" onClick={handleCopy}></i>
            </ApplyV2Tooltip>
            {/*<Tooltip*/}
            {/*    label={t('5708', 'Copy')}*/}
            {/*    openDelay={1}*/}
            {/*    hasArrow*/}
            {/*    bg={'#323234'}*/}
            {/*    borderRadius={'4px'}*/}
            {/*    px={'16px'}*/}
            {/*    py={'8px'}*/}
            {/*    fontSize={'xs'}*/}
            {/*    placement={'auto'}*/}
            {/*    closeOnScroll*/}
            {/*    shouldWrapChildren*/}
            {/*>*/}
            {/*    <i className="fa-regular fa-clone ContactPerson__modal__icon" onClick={handleCopy}></i>*/}
            {/*</Tooltip>*/}
        </Flex>
    )
}

export default PersonContactLink
